

















































import Vue from "vue";
import { rules } from "../services/validation";
import * as types from "../store/types";
import { mapGetters, mapActions } from "vuex";

export default Vue.extend({
  name: "SignInForm",

  props: {
    secondary: {
      type: Boolean,
      default: false,
    },
  },

  data: () => {
    return {
      rules,
      formValue: { email: "", password: "" },
    };
  },

  computed: {
    ...mapGetters({
      loggedIn: types.IS_LOGGED_IN,
      loggingIn: types.LOGGING_IN,
      saving: types.SAVING_FORM,
      errorMessage: types.BAD_CREDS,
    }),
  },

  methods: {
    ...mapActions({
      login: types.LOGIN,
    }),
    submit() {
      // @ts-ignore
      if (!this.$refs.form.validate()) return;

      this.login(this.formValue);
    },
  },

  watch: {
    loggedIn: {
      immediate: true,
      handler() {
        if (this.loggedIn)
          this.$router.push({
            path: "/my-account",
          });
      },
    },
  },
});
